import { Reveal } from "@/components/common/Reveal";

export const SectionHeading = ({ eyebrow, title, body, align = "left", dark = false, className = "" }) => {
  const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <Reveal className={`max-w-2xl ${alignCls} ${className}`}>
      {eyebrow && <p className="eyebrow mb-3">{eyebrow}</p>}
      <h2
        className={`text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight ${
          dark ? "text-white" : "text-ink-heading"
        }`}
      >
        {title}
      </h2>
      {body && (
        <p className={`mt-4 text-base leading-relaxed ${dark ? "text-slate-300" : "text-ink-body"}`}>
          {body}
        </p>
      )}
    </Reveal>
  );
};
